"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inAppMenu;
var _constants = require("./constants");
var _oneWeir = require("@weirgroup/one-weir");
const initialState = {
  menuItems: [],
  selectedMenu: undefined
};
function inAppMenu() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _constants.CONSTANTS.GET_NAVIGATION_FULFILLED:
      {
        const menuItems = action.payload;
        let selectedMenu = state.selectedMenu;
        if (state.selectedMenu === undefined) {
          selectedMenu = menuItems[0];
        }
        return {
          ...state,
          menuItems,
          selectedMenu
        };
        // if (action.payload.data.success) {
        // 	const menuItems = action.payload.data.result[0].children;
        // 	const selectedMenu = action.payload.data.result[0].children[0].link;
        // 	return {
        // 		...state,
        // 		menuItems,
        // 		selectedMenu,
        // 	};
        // }
        // toastStatus.error(action.payload.data.result);
        // return state;
      }
    case _constants.CONSTANTS.ON_INAPP_SELECT:
      {
        const selectedMenu = action.payload;
        return {
          ...state,
          selectedMenu
        };
      }
    default:
      return state;
  }
}